<template>
    <div :class="['day-item', dayStatusClass]" @click="onAddClick">
        <vudal :name="modalName">
            <div class="content">
                <div class="form-group" v-if="errors.length" >
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </div>
                <div class="form-group" style="display:none;">
                    {{ selectedItem.id }} <br/>
                    {{ dayItem.dateId }}
                </div>
                <div class="form-group">
                    <label for="userSelect">Wybierz użytkownika</label>
                    <select class="form-control" id="userSelect" v-model="selectedItem.user">
                        <option v-for="user in users" :key="user">
                            {{ user }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="fromTime">Czas od</label>
                    <input type="time" class="form-control" id="fromTime" v-model="selectedItem.dayTimeSpan.from">
                </div>
                <div class="form-group">
                    <label for="toTime">Czas do</label>
                    <input type="time" class="form-control" id="toTime" v-model="selectedItem.dayTimeSpan.to">
                </div>
                <div class="row ">
                    <div class="col-6">
                        <button class="btn btn-primary btn-sm torre-btn mr-3" @click="onFormSubmit" >Zapisz</button>
                        <button class="btn btn-secondary btn-sm" @click="hidePopup" >Anuluj</button>
                    </div>
                    <div class="col-6 text-right">
                        <button v-if="editMode" class="btn btn-dark btn-sm" @click="onDeleteClick()" >Usuń</button>
                    </div>
                </div>
            </div>
        </vudal>
        <h6 :class="dayClass">{{ dayItem.day }}</h6>
        <ul>
            <li v-for="entry in sortedEntries" :key="entry.id" >
                <div class="list-item" @click.stop="onEditEntryClick(entry)">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 text-left">
                                {{ entryInfo(entry) }}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li v-if="showErrorInfo">
                <div class="list-item schedule-alert-list-item" @click.stop="onEditEntryClick(entry)">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 text-left">
                                {{ dayErrorInfo }}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vudal from 'vudal'
import moment from 'moment'
import restClient from "./ScheduleRestClient"
import un from 'underscore'
import alertify from 'alertifyjs'

export default {
    components: { Vudal },
    props: {
        "dayItem": {
            type: Object,
            required: true
        },
        "users": {
            required: true
        }
    },
    data() {
        return {
            editMode: false,
            errors: [],
            selectedItem: {
                id: 0,
                user: "",
                dayTimeSpan: {
                    from: "",
                    to: ""
                }
            },
            modalName: this.dayItem.dateId
        }
    },
    created() {
    },
    watch: {},
    computed: {
        dayErrorInfo() {
            return `Brakuje: ${this.dayItem.status.missingWorkTime}`
        },
        showErrorInfo() {
            return this.dayItem.status.invalid
        },
        dayStatusClass() {
            if (this.dayItem.status) {
                return this.dayItem.status.invalid ? "schedule-alert" : ""
            }
            return ""
        },
        dayClass() {
            if (this.dayItem.isToday)
                return "today"
            return this.dayItem.isCurrentMonth ? "" : "other-month"
        },
        sortedEntries() {
            return un.sortBy(this.dayItem.entries, (item) => {
                return item.dayTimeSpan.from
            })
        }
    },
    methods: {
        entryInfo(entry) {
            return entry.dayTimeSpan.from + " do " + entry.dayTimeSpan.to + " " + entry.user
        },
        onDeleteClick() {
            const idToDelete = this.selectedItem.id
            restClient.deleteDayInfo(idToDelete)
            .then(res => {
                this.hidePopup()
                this.notifyDataChanged()
            })
            .catch(err => {
                console.log(err)
                this.hidePopup()
                this.showError(err)
            })
        },
        onEditEntryClick(entry) {
            this.editMode = true
            this.selectedItem.id = entry.id
            this.selectedItem.user = entry.user
            this.selectedItem.dayTimeSpan = entry.dayTimeSpan
            this.showPopup()
        },
        showPopup() {
            this.errors = []
            this.$modals[this.modalName].$show()
        },
        hidePopup() {
            this.editMode = false
            this.$modals[this.modalName].$hide()
        },
        validate() {
            this.errors = []
            if (this.selectedItem.user === "") {
                this.errors.push("Wybierz użytkownika")
            }
            if (this.selectedItem.dayTimeSpan.from === "") {
                this.errors.push("Podaj czas początkowy")
            }
            if (this.selectedItem.dayTimeSpan.to === "") {
                this.errors.push("Podaj czas końcowy")
            }
        },
        onFormSubmit() {
            this.validate()
            if (this.errors.length)
                return
            if (this.selectedItem.id) {
                this.updateDayInfo()
            } else {
                this.addDayInfo()
            }
        },
        notifyDataChanged() {
            this.$eventHub.$emit('dataChanged', {});
        },
        updateDayInfo() {
            const params = {
                dayInfoId: this.selectedItem.id,
                data: {
                    "user": this.selectedItem.user,
                    "torreDate": {
                        "localDate": this.dayItem.dateId
                    },
                    "dayTimeSpan": this.selectedItem.dayTimeSpan
                }
            }
            restClient.updateDayInfo(params)
            .then(res => {
                this.hidePopup()
                this.notifyDataChanged()
            })
            .catch(err => {
                console.log(err)
                this.hidePopup()
                this.showError(err)
            })
        },
        onAddClick() {
            this.editMode = false
            this.selectedItem = {
                id: 0,
                user: "",
                dayTimeSpan: {
                    from: "",
                    to: ""
                }
            }
            this.showPopup()
        },
        addDayInfo() {
            const params = {
                "user": this.selectedItem.user,
                "torreDate": {
                    "localDate": this.dayItem.dateId
                },
                "dayTimeSpan": this.selectedItem.dayTimeSpan
            }
            restClient.addDayInfo(params)
            .then(res => {
                this.hidePopup()
                this.notifyDataChanged()
            })
            .catch(err => {
                console.log(err)
                this.hidePopup()
                this.showError(err)
            })
        },
        showError(err) {
            const body = err.response.data
            if (body && body.errors && body.errors[0]) {
                const msg = body.errors[0].defaultMessage
                alertify.set('notifier','position', 'top-center');
                alertify.error(msg).delay(3)
                
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    $torre-green: #97b84d;
    $torre-red:rgba(212, 100, 100, 0.4);
    $torre-red-hover:rgba(212, 100, 100, 0.7);

    .today {
        font-weight: bold;
        color: $torre-green;
    }

    .other-month {
        opacity: .4;
    }

    .day-item {
        display: flex; 
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
    .schedule-alert {
        background: $torre-red;
        &:hover {
            background: #ddd;
        }
    }
    span {
        display: block;    
    }
    h6 {
        text-align: end;
        padding-top: 1px;
        padding-right: 3px;   
    }
    ul {
        list-style: none;
        margin: 0px;
        padding: 0px;
        li {
            font-size: 10px;
        }
    }
    .list-item {
        display: flex; 
        flex-direction: row;
        margin: 1px 10px;
        border-radius: 3px;
        background: $torre-green;
        &:hover {
            cursor: pointer;
            background: #6f8b33;
        }
        i {
            text-align: end;
            &:hover {
                background: #343a40;
                border-radius: 6px;
            }
        }
    }

    .schedule-alert-list-item {
        background: $torre-red;
        &:hover {
            cursor: pointer;
            background: $torre-red-hover;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleDay.vue